import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;

export const STATE_URL = APIURL+"/location/states/";

// CREATE =>  POST: create a new state to the server
export function createState(state) {
	const result = axios.post(`${STATE_URL}create`, state);
	return result
}

// READ
export function getAllStates() {
  return axios.get(STATE_URL);
}

export function getStateById(stateId) {
	const result = axios.get(`${STATE_URL}find/${stateId}`);
	return result;
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findStates(queryParams) {
  const result = axios.post(`${STATE_URL}find`, { queryParams });
  return result;
}

// UPDATE => PUT: update the state on the server
export function updateState(state) {
  return axios.post(`${STATE_URL}update/${state.id}`, { state });
}

// UPDATE Status
export function updateStatusForStates(ids, status) {
  return axios.post(`${STATE_URL}updateStatusForStates`, {
    ids,
    status
  });
}

// UPDATE single Status
export function updateStatusForState(id, status) {
  return axios.post(`${STATE_URL}updateStatusForState`, {
    id,
    status
  });
}

export function createStateByName(name) {
  return axios.post(`${STATE_URL}create`, {
    name
  });
}

export function updateRecordForState(id,name) {
  return axios.post(`${STATE_URL}updateRecordForState`, { id, name});
}

// DELETE => delete the state from the server
export function deleteState(id) {
 return axios.post(`${STATE_URL}delete`, { id });
}

// DELETE States by ids
export function deleteStates(ids) {
  return axios.post(`${STATE_URL}deleteStates`, { ids });
}
